import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useTheme } from '@mui/material';
const UsageManualPdfViewer = ({ documentUrl, title, height = 560 }) => {
    const theme = useTheme();
    return (_jsx(Box, { sx: {
            width: '100%',
            height,
            borderRadius: 2,
            overflow: 'hidden',
            border: `1px solid ${theme.palette.divider}`,
            bgcolor: theme.palette.grey[100]
        }, children: _jsx(Box, { component: 'iframe', src: documentUrl, title: title, sx: {
                width: '100%',
                height: '100%',
                border: 'none',
                display: 'block'
            } }) }));
};
export default UsageManualPdfViewer;
